import { type GetMetricQueryParams } from '@gonfalon/openapi/operations/getMetric';
import { type QueryOptions, useQueries } from '@tanstack/react-query';

import { createQueryHook } from '../internal/createQueryHook';
import { getMetricDetailsQuery, metrics } from '../queries/metrics';

/**
 * @deprecated Use `metrics.detail()` with `useQuery` directly.
 */
export const useMetric = createQueryHook(metricQuery);

/**
 * @deprecated Use `getMetricDetailsQuery()` with `useQuery` directly.
 */
export const useMetricDetails = createQueryHook(getMetricDetailsQuery);

export function useMetricQueries(
  {
    projectKey,
    metricKeys,
    params,
  }: {
    projectKey: string;
    metricKeys: string[];
    params?: GetMetricQueryParams;
  },
  options?: QueryOptions,
) {
  return useQueries({
    ...options,
    queries: metricKeys.map((metricKey) => metricQuery({ projectKey, metricKey, params })),
  });
}

function metricQuery({
  projectKey,
  metricKey,
  params,
}: {
  projectKey: string;
  metricKey: string;
  params?: GetMetricQueryParams;
}) {
  return metrics.detail({ projectKey, metricKey, params });
}
